import { getSwappedValues, getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { sportIdMapConfig } from "../config";
export const createTeamsAdditionalScore = (sportId, team1Total, team2Total, additionalScores = {}, isTeamSwap) => {
    var _a, _b;
    if (team1Total || team2Total) {
        return ((_b = (_a = sportIdMapConfig[sportId]) === null || _a === void 0 ? void 0 : _a.createAdditionalScores) === null || _b === void 0 ? void 0 : _b.call(_a, additionalScores, getTruthyValue(team1Total, "-"), getTruthyValue(team2Total, "-"), isTeamSwap)) || getSwappedValues(isTeamSwap, [getTruthyValue(team1Total, "-")], [getTruthyValue(team2Total, "-")]);
    }
    return [[], []];
};
//# sourceMappingURL=createAdditionalScores.js.map